"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDITORIAL_CAROUSEL_SLIDE_MOBILE_MIN_WIDTH = exports.EDITORIAL_CAROUSEL_SLIDE = exports.EDITORIAL_CAROUSEL = void 0;
const EDITORIAL_CAROUSEL = exports.EDITORIAL_CAROUSEL = 'editorial-carousel';
const EDITORIAL_CAROUSEL_SLIDE = exports.EDITORIAL_CAROUSEL_SLIDE = 'editorial-carousel-slide';
const EDITORIAL_CAROUSEL_SLIDE_MOBILE_MIN_WIDTH = exports.EDITORIAL_CAROUSEL_SLIDE_MOBILE_MIN_WIDTH = 240;
//# sourceMappingURL=constants.js.map